import React, { Component } from 'react';
import { Segment, Radio, Form, Label } from 'semantic-ui-react';

function monthDiff(d1, d2) {
    return d2.getMonth() - d1.getMonth() +
        (12 * (d2.getFullYear() - d1.getFullYear()))
}

class RatingDates extends Component {

    render() {
        const { ratingDates, readOnly, ratingPeriod } = this.props;

        /* 
         * 04/27/2020
         * Function calculates how many full calendar months are between dates
         * WARNING: At the time of this writing, javascript dates have a month component
         * that are zero indexed. 
         */
        const ratingEffectiveDate = (dates) => {
            const [month, day, year] = dates.nextRatingEffectiveDate.split("/")
            return new Date(year, month - 1, day)
        };

        return (
            <Segment>
                <Label color='green' ribbon>Select the rating period you are applying for:</Label>
                <Form.Group grouped>
                    <Form.Field>
                        <Radio
                            label={ratingDates.issuedRatingEffectiveDate}
                            name='ratingPeriod'
                            value={ratingDates.issuedRatingEffectiveDate}
                            disabled={readOnly}
                            onChange={this.props.onRatingDateChange}
                            checked={ratingPeriod === ratingDates.issuedRatingEffectiveDate}
                            />
                     </Form.Field>
                    {monthDiff(new Date(), ratingEffectiveDate(ratingDates)) < 7 && (
                        <Form.Field>
                            <Radio
                                label={ratingDates.nextRatingEffectiveDate}
                                name='ratingPeriod'
                                value={ratingDates.nextRatingEffectiveDate}
                                disabled={readOnly}
                                onChange={this.props.onRatingDateChange}
                                    checked={ratingPeriod === ratingDates.nextRatingEffectiveDate} />
                        </Form.Field>
                        )
                    }
                </Form.Group>
            </Segment>
        );
    }
}

export default RatingDates;
